import ApiService from "@/services/api.service";

const UnderwritingService = {
    async getProgrammes(client_id) {
        try {
            let { data } = await ApiService.post(
                'programme',
                {client_id}
            );
            return data;
        } catch (err) {
            // Silently handle error
        }
    },
    async getProgramme(client_id, master_policy_id) {
        try {
            let { data } = await ApiService.post(
                'getProgramme',
                {client_id, master_policy_id}
            );
            return data;
        } catch (err) {
            // Silently handle error
        }
    },
    async getLocalPoliciesForProgramme(master_policy_id, local_policy_id, client_id, currency_type) {
        try {
            let params = {master_policy_id, client_id, currency_type};
            if (local_policy_id) {
                params.local_policy_id = local_policy_id;
            }
            let { data } = await ApiService.post(
                'programme/localPolicies',
                params
            );
            return data;
        } catch (err) {
            // Silently handle error
        }
    },
    async getLocalPoliciesLike(client_id, term) {
        try {
            let { data } = await ApiService.post(
                'programme/localPoliciesLike',
                {client_id, term}
            );
            return data;
        } catch (err) {
            // Silently handle error
        }
    },
    async getCoverageDocument(client_id, master_policy_id, local_policy_id, currency_type) {
        try {
            let { data } = await ApiService.post(
                'programme/coverageDocument',
                {client_id, master_policy_id, local_policy_id, currency_type}
            );
            return data;
        } catch (err) {
            if (err.response?.status !== 404) {
                // Non-404 error — no coverage document for MPol and LPol combination
            }

            return {document: null};
        }
    },
    async getCoverageTemplate(client_id, master_policy_id, currency_type) {
        try {
            let { data } = await ApiService.post(
                'programme/coverageTemplate',
                {client_id, master_policy_id, currency_type}
            );
            return data;
        } catch (err) {
            if (err.response?.status !== 404) {
                // Non-404 error — no coverage template for MPol combination
            }

            return {document: null};
        }
    },
    async getLocations(client_id, master_policy_id, local_policy_id, currency_type) {
        try {
            let { data } = await ApiService.post(
                'programme/locations',
                {client_id, master_policy_id, local_policy_id, currency_type}
            );
            return data;
        } catch (err) {
            if (err.response?.status !== 404) {
                // Non-404 error — no locations for this policy
            }

            return {locations: null};
        }
    },
    async getActivityFeed(client_id, timeframe) {
        try {
            let { data } = await ApiService.post(
                'activityFeed',
                {client_id, timeframe}
            );
            return data;
        } catch (err) {
            // Silently handle error
        }
    }
}

export default UnderwritingService;